import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import { getClientesConectores as getClientesConectoresSdk } from '@sdk/Clientes';

//Action Types
export const Types = {
  GET_CLIENTES_CONECTORES: 'GET_CLIENTES_CONECTORES',
  GET_CLIENTES_CONECTORES_SUCCESS: 'GET_CLIENTES_CONECTORES_SUCCESS',
  GET_CLIENTES_CONECTORES_ERROR: 'GET_CLIENTES_CONECTORES_ERROR',
};

//Action Creators
export const getClientesConectores = () => ({ type: Types.GET_CLIENTES_CONECTORES });
export const getClientesConectoresSuccess = (clientesConectores) => ({ type: Types.GET_CLIENTES_CONECTORES_SUCCESS, clientesConectores });
export const getClientesConectoresError = (error) => ({ type: Types.GET_CLIENTES_CONECTORES_ERROR, error });

//saga
function* fetchGetClientesConectores(action) {
  try {
    const clientes = yield call(getClientesConectoresSdk);
    yield put(getClientesConectoresSuccess(clientes));
  } catch (err) {
    Notification.error(err.message);
    yield put(getClientesConectoresError(err));
  }
}
export const saga = [takeLatest(Types.GET_CLIENTES_CONECTORES, fetchGetClientesConectores)];

// Reducer
const initialState = Map({
  clientesConectores: List(),

  loadingClientesConectores: false,
  successClientesConectores: false,
  errorClientesConectores: false,
});

const handleGetClientesConectores = (state, action) => {
  return state
    .set('loadingClientesConectores', true)
    .set('successClientesConectores', false)
    .set('errorClientesConectores', false)
    .set('successPostConfiguracao', false);
};

const handleGetClientesConectoresSuccess = (state, action) => {
  const { clientesConectores } = action;
  return state
    .set('clientesConectores', List(clientesConectores))
    .set('loadingClientesConectores', false)
    .set('successClientesConectores', true)
    .set('errorClientesConectores', false);
};

const handleGetClientesConectoresError = (state, action) => {
  return state.set('loadingClientesConectores', false).set('successClientesConectores', false).set('errorClientesConectores', action.error);
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_CLIENTES_CONECTORES:
      return handleGetClientesConectores(state, action);
    case Types.GET_CLIENTES_CONECTORES_SUCCESS:
      return handleGetClientesConectoresSuccess(state, action);
    case Types.GET_CLIENTES_CONECTORES_ERROR:
      return handleGetClientesConectoresError(state, action);

    default:
      return state;
  }
}
